var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 16.2436 2.32427 17.4114 2.89287 18.4235L2.0411 20.9788C1.83919 21.5845 2.41546 22.1608 3.02118 21.9589L5.57649 21.1071C6.58863 21.6757 7.75644 22 9 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00137 6.5C9.06155 4.00434 11.075 2 13.55 2H17.45C19.9629 2 22 4.06621 22 6.61501C22 9.70611 19.3539 11.6566 17.1634 12.6237C16.1354 9.0862 12.8704 6.50062 9.00137 6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsAlt);
export default __webpack_public_path__ + "static/media/comments-alt.79bf21c8b882520d7c6936646411c5fc.svg";
export { ForwardRef as ReactComponent };